import type { ITask, ITasksExecutionFlow } from '~/types/app-setup'

import config from '~/config'
import { request } from '~/utils/request'

/** App setups */

export const createAppSetup = ({
  appKey,
  deviceType,
  taskIds,
}: {
  appKey: string
  deviceType: string
  taskIds: string[]
}): Promise<string[]> => {
  return request({
    data: { task_ids: taskIds },
    method: 'POST',
    url: `${config.APP_API}/app-key/${appKey}/device-type/${deviceType}/app-setup/start`,
  })
}

export const getAppSetup = (appKey: string, deviceType: string): Promise<ITasksExecutionFlow> => {
  return request({
    url: `${config.APP_API}/app-key/${appKey}/device-type/${deviceType}/app-setup/tasks`,
  })
}

export const executeTask = ({
  appKey,
  deviceType,
  taskId,
}: {
  appKey: string
  deviceType: string
  taskId: string
}): Promise<void> => {
  return request({
    method: 'POST',
    url: `${config.APP_API}/app-key/${appKey}/device-type/${deviceType}/app-setup/tasks/${taskId}/execute?force=true`,
  })
}

/** Tasks */

export const getTasks = (): Promise<ITask> => {
  return request<ITask>({
    url: `${config.APP_API}/app-setup/tasks`,
  })
}

export const createTask = (
  payload: Omit<ITask, 'created_at' | 'updated_at' | 'created_by' | 'updated_by'>
): Promise<ITask> => {
  return request<ITask>({
    data: payload,
    method: 'POST',
    url: `${config.APP_API}/app-setup/tasks`,
  })
}

export const deleteTask = (taskId: string): Promise<void> => {
  return request<void>({
    method: 'DELETE',
    url: `${config.APP_API}/app-setup/tasks/${taskId}`,
  })
}

export const editTask = ({
  payload,
}: {
  payload: Omit<ITask, 'created_at' | 'updated_at' | 'created_by' | 'updated_by'>
}): Promise<ITask> => {
  return request<ITask>({
    data: payload,
    method: 'PUT',
    url: `${config.APP_API}/app-setup/tasks/${payload.id}`,
  })
}
